import axios from "axios";

import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const getUserFirstLast = () => {
  try {
    return axios.get(BASE_URL + "feed/getUserFirstLast", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const createTicket = (ticket_data, media) => {
  try {
    return axios.post(
      BASE_URL + "tickets/createTicket",
      { ticket_data, media },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const addNewTicketData = (
  ticket_id,
  ticket_data,
  media,
  ticket_status,
) => {
  try {
    return axios.post(
      BASE_URL + "tickets/addNewTicketData",
      { ticket_id, ticket_data, media, ticket_status },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsersTickets = () => {
  try {
    return axios.post(
      BASE_URL + "tickets/getAllUsersTickets",
      {},
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteTicket = (ticket_id) => {
  try {
    return axios.post(
      BASE_URL + "tickets/deleteTicket",
      { ticket_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const fileUpload = (file) => {
  try {
    return axios.post(BASE_URL + "chat/fileUpload", file, {
      "content-type": "multipart/form-data",
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTickets = () => {
  try {
    return axios.post(
      BASE_URL + "tickets/getTickets",
      {},
      { "content-type": "multipart/form-data", headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getTicketThread = (ticket_id) => {
  try {
    return axios.post(
      BASE_URL + "tickets/getTicketThread",
      { ticket_id },
      { "content-type": "multipart/form-data", headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getUserType = () => {
  try {
    return axios.get(BASE_URL + "auth/getUserType", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getUsersTimeSaved = (pastMonths) => {
  try {
    return axios.post(
      BASE_URL + "chat/getUsersTimeSaved",
      { pastMonths },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const adminNewUser = (
  email,
  mfa_email,
  first_name,
  last_name,
  role,
  password,
) => {
  try {
    return axios.post(
      BASE_URL + "auth/signupNewUser",
      { email, mfa_email, first_name, last_name, role, password },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const adminLockAccount = (email) => {
  try {
    return axios.post(
      BASE_URL + "auth/lockAccount",
      { email },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const adminResetPassword = (email, newPassword) => {
  try {
    return axios.post(
      BASE_URL + "auth/resetPassword",
      { email, newPassword },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const adminUpdateAccount = (email, updateField, updateAttribute) => {
  try {
    return axios.post(
      BASE_URL + "auth/updateUserAccountAdmin",
      { email, updateField, updateAttribute },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const userUpdateAccount = (updateField, updateAttribute) => {
  try {
    return axios.post(
      BASE_URL + "auth/updateUserAccount",
      { updateField, updateAttribute },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const userUpdatePassword = (password, newPassword) => {
  try {
    return axios.post(
      BASE_URL + "auth/userUpdatePassword",
      { password, newPassword },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsers = () => {
  try {
    return axios.post(
      BASE_URL + "auth/getAllUsers",
      {},
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getMfaToggle = () => {
  try {
    return axios.get(BASE_URL + "settings/getMfaToggle", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateMfa = (mfa) => {
  try {
    return axios.post(
      BASE_URL + "settings/updateMfa",
      { mfa },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getLightDarkMode = () => {
  try {
    return axios.get(BASE_URL + "settings/getLightDarkMode", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateLightDarkMode = (dark_mode) => {
  try {
    return axios.post(
      BASE_URL + "settings/updateLightDarkMode",
      { dark_mode },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

// ═══════════════════════════════════════════
//  Public Models — LiteLLM
// ═══════════════════════════════════════════

/** Fetch the full LiteLLM chat-model catalog (grouped by provider). */
export const getLitellmModels = () => {
  try {
    return axios.get(BASE_URL + "settings/getLitellmModels", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

/** Fetch saved provider configs (credentials masked). */
export const getPublicModels = () => {
  try {
    return axios.get(BASE_URL + "settings/getPublicModels", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

/**
 * Save/update a provider's credentials, enabled models, and active model.
 *
 * @param {string}   provider        — e.g. "openai", "bedrock"
 * @param {object}   credentials     — { api_key: "...", api_base: "...", ... }
 *                                      only send non-empty values for fields that changed
 * @param {boolean}  enabled         — provider-level toggle
 * @param {string[]} enabled_models  — model keys toggled on
 * @param {string}   active_model    — the single globally-active model key
 */
export const updatePublicModel = (
  provider,
  credentials,
  enabled,
  enabled_models,
  active_model,
) => {
  try {
    return axios.post(
      BASE_URL + "settings/updatePublicModel",
      { provider, credentials, enabled, enabled_models, active_model },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

/** Remove a provider's config entirely. */
export const deletePublicModel = (provider) => {
  try {
    return axios.post(
      BASE_URL + "settings/deletePublicModel",
      { provider },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

/** Get the globally-active model (any user can call). */
export const getActiveModel = () => {
  try {
    return axios.get(BASE_URL + "settings/getActiveModel", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};
